var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wobao-intelligent-booking-container" },
    [
      _vm.dialogVisible
        ? _c("intelligent-booking-result-multi", {
            attrs: {
              visible: _vm.dialogVisible,
              "detail-list": _vm.detailList,
              source: _vm.source
            },
            on: {
              close: _vm.handleClose,
              success: _vm.handleSuccess,
              copyIntelligentDocument: _vm.handleCopyIntelligentDocument
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }